<div class="clearfix"></div>

<!-- Title Header Start -->
<!-- <section class="inner-header-title" style="background-image:url(assets/img/bn2.jpg);  ">
    <div class="container">
        <h3>Admin LogIn</h3>
    </div>
</section>
<div class="clearfix"></div> -->
<!-- Title Header End -->

<!-- Tab Section Start -->
<section class="tab-sec gray">
    <div class="main-login">
        <div class="left-img">
            <img src="assets/img/Login Image.png" alt="">
        </div>
        <div class="new-logwrap">
            <div class="tab-content">
                <div>
                    <h3>Admin LogIn</h3>

                    <div class="form-group">
                        <label>Mobile Number</label>
                        <div class="input-with-icon">
                            <input type="email" [readonly]="isCid" [(ngModel)]="emailOrPhone"
                                (keyup.enter)="getUsersByPhNo()" class="form-control"
                                placeholder="Enter Your Mobile Number">
                            <i class="theme-cl ti-email"></i>
                        </div>
                    </div>

                    <div class="form-group" *ngIf="companyList.length != 0">
                        <label>Select Company</label>
                        <div class="cid-block">
                            <div class="cid-list" [style.cursor]="list.isSelected ? 'default' : 'pointer'"
                                [class.selected]="list.isSelected" *ngFor="let list of companyList">
                                <p (click)="!list.isSelected ? companySelect(list) : null">
                                    {{list.companyName || list.cid || ''}} <i *ngIf="list.isSelected"
                                        (click)="removeCompany(); $event.stopPropagation()" class="bi bi-x-circle"></i>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" *ngIf="isPassword">
                        <label>Password</label>
                        <div class="input-with-icon" style="position: relative;">
                            <input type="{{showPassword}}" #passwordField [(ngModel)]="password" class="form-control"
                                placeholder="Enter Your Password" style="padding-right: 40px;">
                            <i class="theme-cl ti-lock"></i>
                            <i class="bi" [ngClass]="showPassword === 'password' ? 'bi-eye-slash' : 'bi-eye'"
                                (click)="togglePasswordIcon()"
                                style="position: absolute; right: 15px; left: auto !important; top: 50%; transform: translateY(-50%); cursor: pointer; color: #666; pointer-events: auto;"></i>
                        </div>
                    </div>
                    <div class="forgot-password" *ngIf="isPassword">
                        <p><input [(ngModel)]="rememberMe" type="checkbox"> Remember me</p>
                        <a style="cursor: pointer;" (click)="goToForgotPassword()">Forgot password</a>
                    </div>
                    <div class="form-group" *ngIf="authenticationInput">
                        <label>Authentication Code</label>
                        <div class="input-with-icon">
                            <input type="text" [(ngModel)]="otp" class="form-control"
                                placeholder="Enter Authentication Code">
                            <i class="theme-cl ti-lock"></i>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                        <label>User Type</label>
                        <select name="" id="" [(ngModel)]="userType" style="background-color:#e7f0fe;border-radius: 5px;" class="form-control">
                            <option value="{{role.roleName}}" *ngFor="let role of roles">{{role.roleName}}</option>
                        </select>
                    </div> -->

                    <div class="form-groups login-button">
                        <button type="submit" style="background-color: #24233d;" (click)="login()"
                            *ngIf="isPassword && !authenticationInput" (window:keydown.enter)="login()"
                            class="btn btn-primary full-width" [disabled]="loginButton">
                            {{ loginButton ? 'Processing...' : 'Log In' }}
                        </button>
                        <button type="submit" style="background-color: #24233d;" (click)="getUsersByPhNo()"
                            *ngIf="isNextbutton" (window:keydown.enter)="getUsersByPhNo()"
                            class="btn btn-primary full-width">Next</button>
                        <button type="submit" style="background-color: #24233d;" (click)="login()"
                            *ngIf="authenticationInput" (window:keydown.enter)="login()"
                            class="btn btn-primary full-width" [disabled]="loginButton">
                            {{ loginButton ? 'Processing...' : 'Log In' }}
                        </button>
                    </div>
                    <div class="app-version">
                        v{{ appVersion }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>